// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-tabs[data-v-3bec5383] .nav-link.active {\n  color: #2db782;\n  padding-bottom: 5px;\n  border-bottom: 3px #2db782 solid !important;\n}\n.download-tariff-sheet-dropdown[data-v-3bec5383] {\n  margin-left: 8px;\n}\n.download-tariff-sheet-dropdown[data-v-3bec5383] .btn {\n  padding: 3px 15px;\n}\n.download-tariff-sheet-dropdown.success[data-v-3bec5383] .btn {\n  background-color: #2db782;\n  color: white;\n  font-weight: 500;\n}", ""]);
// Exports
module.exports = exports;
